import { PlateRenderLeafProps, useEditorRef } from '@udecode/plate';
import * as React from 'react';
import { Editor } from 'slate';

import { MARK_COMMENT_ID } from './createCommentPlugin';
import { useComments } from './useComments';
import { getCommentNodeEntry } from './utils';

export const CommentLeaf = ({
  attributes,
  children,
  leaf,
}: PlateRenderLeafProps & { leaf: { [key in string]: string } }) => {
  const setActiveComment = useComments((s) => s.setActiveComment);
  const editor = useEditorRef();
  return (
    <span
      {...attributes}
      onClick={() => {
        const nodeEntry = getCommentNodeEntry(leaf[MARK_COMMENT_ID], editor);
        if (nodeEntry) {
          const pathT = nodeEntry[1];
          const range = {
            anchor: {
              path: pathT,
              offset: 0,
            },
            focus: Editor.end(editor, pathT),
          };
          setActiveComment({ selection: range, id: leaf[MARK_COMMENT_ID] });
        }
      }}
      className="bg-yellow-200 cursor-pointer"
    >
      {children}
    </span>
  );
};
